import {
  Annotation,
  Axis,
  Chart,
  Coordinate,
  G2,
  Interval,
  Legend,
  Line,
  Point,
  Tooltip,
} from 'bizcharts';
import { IEvent } from 'bizcharts/lib/interface';
import { TraderOrderRankChartDataType } from './OrderCountRankChart';
import { useEffect, useState } from 'react';
import useFetch from '../../api/useFetch';
import { traderRankGetRequestApi } from '../../api/apiConfig';
import { formatDashFormToEightDigitString } from '../../function/replaceString';
import { useOrderAmountRankChart } from './provider/OrderAmountRankChartProvider';
import { useProdAmountPriceChart } from './provider/ProdAmountPriceChartProvider';

export const ProdAmountPriceBarChart = () => {
  const { filteredData } = useProdAmountPriceChart();
  let chartIns: G2.Chart | null = null;
  const scale = {
    percent: {
      min: 0,
      tickCount: 4,
      alias: '주문수량',
      type: 'linear',
      formatter: (d: number) => `${d.toLocaleString()}개`, // 금액 포맷팅 (1000 단위 쉼표 추가 및 '원' 추가)
    },
  };

  const colors = ['#699bff', '#fd6666'];

  return (
    filteredData.length > 0 && (
      <div>
        <Chart
          scale={scale}
          autoFit
          height={400}
          data={filteredData.sort((a, b) => a.percent - b.percent)}
          // padding={[40, 40, 50, 105]}
          onGetG2Instance={(chart: G2.Chart) => {
            chartIns = chart;
          }}
        >
          <Axis
            name='prodDes'
            label={{
              formatter: (text) =>
                text.length > 8 ? text.slice(0, 8) + '...' : text, // 10글자 초과 시 "..."
              style: {
                fontSize: 12,
                fill: '#333',
              },
            }}
          />
          <Coordinate transpose />
          <Interval position='prodDes*percent' color={colors[0]} size={15} />
        </Chart>
      </div>
    )
  );
};
